
bq.formFill = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.$form = false;
  this.$response = false;
  this.active = false;
};

bq.formFill.DEFAULTS = {
  ajaxUrl: false,
  data: false,
  form: false,
  params: false,
  scroll: true,
  clearScroll: '#sb-site',
  clearAction: '.form-fill-clear',
  clearEvent: false
};

bq.formFill.prototype = {
  init: function() {
    bq.debug.log("Form Fill : init()", this.$element);
    this.$form = $(this.options.form);
    if(this.$form.length <= 0 || (!this.options.ajaxUrl && !this.options.data)) {
      bq.debug.error("Form Fill : required data-* missing", this);
      return;
    }

    this.$element.on('click', {context:this}, this._catchClickEvent);
    this.$element.on('bq.formfill.fill', {context:this}, this._catchFillEvent);
    this.$form.bind('reset', {context:this}, this._catchFormResetEvent);

    if(this.options.clearAction) {
      this.$form.find(this.options.clearAction).on('click', {context:this}, this.__catchClearEvent);
    }

  },

  _getAjaxData: function() {
    if(this.active) { return false; }

    var $this = this;
    var params = {"'ajax": true};

    if(this.options.params) { params = $.extend(this.options.params, params); }

    bq.helper.throwEvent("bq.formFill.processStart", this.$element);

    $.getJSON( this.options.ajaxUrl, params )
      .done(function( json ) {

        if(json.error === true || json.error === 'true') {
          $this.active = false;
        } else {
          $this._processData(json);
        }

      })
      .fail(function( jqxhr, textStatus, error ) {
        var err = textStatus + ", " + error;
        bq.debug.error("Form Fill : update : ajax error : " + err, $this);

        $this.active = false;
      })
      .always(function(data, textStatus, jqXHR) {
        bq.helper.throwEvent("bq.formFill.processEnd", $this.$element);
        $this.active = false;
      });
  },

  _processData: function(data) {
    var fillData = false;

    if(data) {
      fillData = data;
    } else if(this.options.data) {
      fillData = data;
    } else {
      if(this.options.ajaxUrl) {
        this._getAjaxData();
      }
    }

    if(!fillData) { return false; }

    if(data.selectdata) {
      this._updateSelectData(data.selectdata);
    }

    if(data.data) {
      this._fillForm(data.data);
    } else {
      this._fillForm(data);
    }

    if(data.messages) {
      this._updateMessaging(data.messages);
    }

    if(data.event) {
      this._sendEvents(data.event);
    }

  },

  _updateSelectData: function(data) {

    $.each(data, function(k,v){
        var $input = $('[name="'+k+'"]');
        var $select = $input.closest('[data-bq="selectbox-data"]');
        if($select) {
            bq.helper.throwEvent('bq.selectboxdata.update', $select, {results:v});
        }
    });
  },

  _fillForm: function(data) {

    $.each(data, function(k,v){
      var $el = $('[name="'+k+'"]');
      if($el) {
        if($el.is(':checkbox') || $el.is(':radio')) {
          if($el.val() == v) {
            $el.prop('checked', true);
          } else {
            $el.prop('checked', false);
          }
        } else if($el.is('select')) {
          if($el.find("option[value='" + v + "']").length >= 1) {
            $el.val(v);
          } else {
            $el.find("option").filter(function() {
                  return $(this).text() == v;
              }).prop("selected", true);
          }
        } else {
          $el.val(v);
        }

        $el.trigger('change');
      }
    });

    if(this.$form.parsley()) {
      this.$form.parsley().reset();

      // remove bq-validation icons
      this.$form.find('.form-validation-error').remove();
    }

    if(this.options.scroll) {
      bq.helper.smoothScroll(this.$form);
    }
  },

  _clearForm: function(reset) {
    if(reset) {
      this.$form.trigger('reset');
    }

    var $selects = $('[data-bq="selectbox-data"]', this.$form);

    $selects.trigger('bq.selectboxdata.updateValue');

    if(this.options.clearScroll) {
      bq.helper.smoothScroll(this.options.clearScroll);
    }

    if(this.options.clearEvent) {
        bq.helper.throwEvent(this.options.clearEvent, this.$form);
    }
  },

  _updateMessaging: function(data, revert) {
    var $this = this;
    if(!data && revert) {
      this.$form.find('[data-ff-text]').each(function(){
        var el = $(this);
        el.text(el.data('ffText'));
      });
    } else if(data) {
      $.each(data, function(k,v){
        $this.$form.find(k).each(function(){
          var el = $(this);
          el.attr('data-ff-text', el.text());
          el.text(v);
        });
      });
    }
  },

  _sendEvents: function(data) {
    var $this = this;
    $.each(data, function(k,v){
        bq.helper.throwEvent(k, $this.$form, v);
    });
  },

  _catchClickEvent: function(e) {
    var $this = e.data.context;
    $this._processData(false);
    return false;
  },

  _catchClearEvent: function(e) {
    var $this = e.data.context;

    $this._clearForm(true);
    $this._updateMessaging(false, true);

    return false;
  },

  _catchFormResetEvent: function(e) {
    var $this = e.data.context;

    $this._clearForm(false);
    $this._updateMessaging(false, true);

    //return false;
  },

  _catchFillEvent: function(e, data) {
    var $this = e.data.context,
        fillData = false;

    if(data) {
      fillData = false;
    }

    $this._processData(fillData);
    return false;
  }

};

// FORM FILL PLUGIN DEFINITION
// =======================

var formFillold = $.fn.formFill;

$.fn.formFill = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.formFill');
    var options = $.extend({}, bq.formFill.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.formFill', (data = new bq.formFill(this, options))); }
    data.init();
  });
};

$.fn.formFill.Constructor = bq.formFill;

// FORM FILL NO CONFLICT
// =================

$.fn.formFill.noConflict = function () {
  $.fn.formFill = formFillold;
  return this;
};

// FORM FILL DATA-API
// ==============

bq.formFillInit = function() {
  $('[data-bq="form-fill"]').each(function () {
    var el = $(this);
    if(el.data('bq.formFill')) { return; }
    el.formFill(el.data());
  });
};

bq.init.push(bq.formFillInit);
